module.exports = __webpack_public_path__ + "img/logo-basic-mob.e85f2585.png";